import type { FC } from "react";

import { Button } from "../common/Button";

interface IndexingToolbarProps {
  onRefresh: () => void;
  onTriggerRun: () => void;
  loading?: boolean;
  triggering?: boolean;
}
function resolveTriggerTitle(triggering: boolean): string {
  if (triggering) {
    return "Triggering run...";
  }
  return "Open run configuration";
}

export const IndexingToolbar: FC<IndexingToolbarProps> = ({
  onRefresh,
  onTriggerRun,
  loading = false,
  triggering = false,
}) => {
  const triggerTitle = resolveTriggerTitle(triggering);

  return (
    <div className="flex flex-wrap items-center gap-3">
      <Button
        variant="outline"
        size="sm"
        onClick={onRefresh}
        disabled={loading}
        loading={loading}
        loadingText="Refreshing..."
        title={loading ? "Refreshing data..." : "Refresh run list"}
      >
        Refresh
      </Button>
      <Button
        variant="primary"
        size="sm"
        onClick={onTriggerRun}
        disabled={triggering}
        loading={triggering}
        loadingText="Triggering..."
        title={triggerTitle}
      >
        Trigger Manual Run
      </Button>
    </div>
  );
};
